export function calculateSoftCappedMS(rawMs) {
  if (rawMs <= 415) {
    return rawMs;
  } else if (rawMs <= 490) {
    return 415 + (rawMs - 415) * 0.8;
  } else {
    return 415 + (490 - 415) * 0.8 + (rawMs - 490) * 0.5;
  }
}

export function calculateTangentSliding(vx, vz, nx, nz) {
  const dot = vx * nx + vz * nz;
  let slideVx = vx - dot * nx;
  let slideVz = vz - dot * nz;

  if (Math.hypot(slideVx, slideVz) <= 0.001) {
    slideVx = -nz;
    slideVz = nx;
  }

  return { nx: slideVx, nz: slideVz };
}

export function updateEntityPosition(entity, dt = 0.016, bounds = { minX: -14, maxX: 14, minZ: -14, maxZ: 14 }) {
  if (!entity || entity.isDead || entity.isStunned) return false;

  const targetX = entity.targetX !== undefined ? entity.targetX : entity.x;
  const targetZ = entity.targetZ !== undefined ? entity.targetZ : (entity.z !== undefined ? entity.z : 0);

  const dx = targetX - entity.x;
  const dz = targetZ - (entity.z !== undefined ? entity.z : 0);
  const dist = Math.hypot(dx, dz);

  if (dist <= 0.15) {
    entity.x = targetX;
    if (entity.z !== undefined) entity.z = targetZ;
    entity.isMoving = false;
    entity.isSliding = false;
    return false;
  }

  const ms = calculateSoftCappedMS(entity.ms || 325);
  const moveStep = (ms / 50) * dt;
  const vx = (dx / dist) * Math.min(moveStep, dist);
  const vz = (dz / dist) * Math.min(moveStep, dist);

  entity.x = Math.max(bounds.minX, Math.min(bounds.maxX, entity.x + vx));
  if (entity.z !== undefined) {
    entity.z = Math.max(bounds.minZ, Math.min(bounds.maxZ, entity.z + vz));
  }

  entity.facingAngle = Math.atan2(dx, dz);
  entity.isMoving = true;
  return true;
}
